import { handleActions, Action } from 'redux-actions';
import { pusherEvent, PusherEventPayload } from 'actions/pusher';
import {
  UpdateNotificationsPayload,
  updateNotifications,
  cleanNotifications,
} from 'actions/notifications';
import {
  mapPusherEventPayloadToNotification,
  mapNotificationEntityToNotification,
  orderByDate,
} from 'utils/notifications';
import { CombinedNotificationData } from '../types/notifications';

type NotificationsState = CombinedNotificationData[];

const initialState: NotificationsState = [];

const handlePusherEvent = (
  currentState: NotificationsState,
  { payload }: Action<PusherEventPayload>
) => {
  const notification = mapPusherEventPayloadToNotification(payload);
  const filteredState = currentState.filter(n => n.id !== notification.id);
  return [...filteredState, notification].sort(orderByDate);
};

const handleUpdateNotifications = (
  currentState: NotificationsState,
  { payload }: Action<UpdateNotificationsPayload>
) => {
  const notifications = payload.map(n => mapNotificationEntityToNotification(n));
  const filteredState = currentState.filter(n => !notifications.find(nn => nn.id === n.id));
  return [...filteredState, ...notifications].sort(orderByDate);
};

const reducer = handleActions<NotificationsState, PusherEventPayload & UpdateNotificationsPayload>(
  {
    [pusherEvent as any]: handlePusherEvent,
    [updateNotifications as any]: handleUpdateNotifications,
    [cleanNotifications as any]: () => initialState,
  },
  initialState
);

export default reducer;
